import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    year: {
        id: 'iaso.label.year',
        defaultMessage: 'Years',
    },
    quarter: {
        id: 'iaso.label.quarter',
        defaultMessage: 'Quarter',
    },
    quarter_nov: {
        id: 'iaso.label.quarter_nov',
        defaultMessage: 'Quarter November',
    },    
    financial_nov: {
        id: 'iaso.label.financial_nov',
        defaultMessage: 'Financial Yearly Nov',
    },
    week: {
        id: 'iaso.label.week',
        defaultMessage: 'Week',
    },    
    weekDisplay: {
        id: 'iaso.label.weekDisplay',
        defaultMessage: 'Week N° {weekNumber} ({start} - {end})',
    },        
    month: {
        id: 'iaso.label.month',
        defaultMessage: 'Month',
    },
    day: {
        id: 'iaso.label.day',
        defaultMessage: 'Day',
    },
    six_month: {
        id: 'iaso.label.six_month',
        defaultMessage: 'Semester',
    },
    january: {
        defaultMessage: 'January',
        id: 'iaso.label.months.january',
    },
    february: {
        defaultMessage: 'February',
        id: 'iaso.label.months.february',
    },
    march: {
        defaultMessage: 'March',
        id: 'iaso.label.months.march',
    },
    april: {
        defaultMessage: 'April',
        id: 'iaso.label.months.april',
    },
    may: {
        defaultMessage: 'May',
        id: 'iaso.label.months.may',
    },
    june: {
        defaultMessage: 'June',
        id: 'iaso.label.months.june',
    },
    july: {
        defaultMessage: 'July',
        id: 'iaso.label.months.july',
    },
    august: {
        defaultMessage: 'August',
        id: 'iaso.label.months.august',
    },
    september: {
        defaultMessage: 'September',
        id: 'iaso.label.months.september',
    },
    october: {
        defaultMessage: 'October',
        id: 'iaso.label.months.october',
    },
    november: {
        defaultMessage: 'November',
        id: 'iaso.label.months.november',
    },
    december: {
        defaultMessage: 'December',
        id: 'iaso.label.months.december',
    },
    clear: {
        id: 'iaso.label.clear',
        defaultMessage: 'Clear',
    },
    chronologicalPeriodError: {
        id: 'iaso.formversions.chronologicalPeriodError',
        defaultMessage: 'Start period should be before end period',
    },
    invalidPeriodError: {
        id: 'iaso.formversions.periodError',
        defaultMessage: 'Period not valid',
    },
    noPeriod: {
        id: 'iaso.label.noPeriod',
        defaultMessage: 'No period',
    },
});

export default MESSAGES;
